import { render, staticRenderFns } from "./ErrorOnLoadingDataFeedback.vue?vue&type=template&id=4be3f746&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports